import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import withAnalytics from '../../../hocs/withAnalytics';
import styles from './Button.module.css';

export const Button = ({ text, intents, className, children, ...rest }) => {
  return (
    <button
      {...rest}
      className={classnames(
        styles.Button,
        intents.map((intent) => styles[`Button-${intent}`]),
        className
      )}
    >
      {text || children}
    </button>
  );
};
Button.propTypes = {
  text: PropTypes.node.isRequired,
  children: PropTypes.node,
  intents: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
  target: PropTypes.string,
};
Button.defaultProps = {
  intents: [],
  className: '',
  href: '',
  target: '',
  children: null,
};

export default Button;

export const ButtonWithAnalytics = withAnalytics(Button);
